<template>
    <div v-if="isPageReady" class=" paywithpoint-page mx-auto relative" :theme="theme">
        <div class=" bg-a-gray-f4f4f4" v-if="isLoaded">
            <div v-if="state != 'scanqr'">
                <PWPHeader ref="header" 
                    :lbl="lbl"
                    :blobConfig="landingFlow.states"
                    :rate="dataRate"
                    @clickBack="clickBack()"
                ></PWPHeader>
                <div class="bg-page">
                    <SelectSection
                        v-if="state == 'selecting'"
                        :lbl="lbl"
                        :rate="dataRate"
                        :blobConfig="landingFlow.states"
                        :modalController="modalController"
                        @selectState="changeState($event)">
                    </SelectSection>

                    <!-- QR code Amount State -->
                    <CreateVoucher
                        v-if="state == 'qrcodeamount'"
                        :lbl="lbl"
                        :rate="dataRate"
                        :blobConfig="landingFlow.states"
                        :paymentState="paymentState"
                        :modalController="modalController">
                    </CreateVoucher>

                </div>
                <div  class="absolute bottom-0 w-full">
                    <PWPFooter
                        :lbl="lbl"
                        @clickPdpa="clickPdpa()"
                    ></PWPFooter>
                </div>
            </div>

            <!-- ScanQRState -->
            <div v-if="state == 'scanqr'">
                <ScanQr
                    :lbl="lbl"
                    :rate="dataRate"
                    :blobConfig="landingFlow.states"
                    :modalController="modalController"
                    @selectState="changeState($event)"
                    @updatePaymentState="updatePayment($event)">
                </ScanQr>    
            </div>
        </div>
    </div>

    <ModalMaster :controller="modalController" />
</template>

<script>
import { provide, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

import Util from "@/helper/Utility"
import CacheHelper from "@/helper/CacheHelper"

import useModalStore from "../stroe/ModalStore";
import useAccountStore from "../stroe/AccountStore";
import useLocaleStore from "../stroe/LocaleStore";
import useModalSetup from "../composable/useModalSetup";
import LandingFlow from "../composable/LandingFlow";

import ModalMaster from "@/module/PayWithPoint/component/modal/ModalMaster.vue";
import PWPHeader from '../component/Header/PwpHeader.vue';
import PWPFooter from '../component/Header/PwpFooter.vue';
import CreateVoucher from '../component/Voucher/CreateVoucher.vue';
import SelectSection from '../component/SelectSection/SelectSection.vue';

import CreateQRModel from '../model/CreateQRModel.js'
import Service from '../service/TransferPointService.js'
import ScanQr from "./ScanQr.vue";
import { SerialModel } from "@/core/Redeem/model/SerialModel";

import { useErrorApi } from '@/feature/ErrorApiFeature.js'

export default {
    name: 'PayWithPoint',
    components: {
    ModalMaster,
    PWPHeader,
    PWPFooter,
    CreateVoucher,
    SelectSection,
    ScanQr
},
    setup: function () {
        const ModalStore = useModalStore();
        const modalController =  ModalStore.methods.getModalController()
        const { errorApi } = useErrorApi(modalController)
        const LocaleStore = useLocaleStore()
        const lbl =  LocaleStore.lbl;
        const AccountStore = useAccountStore()
        const route = useRoute()
        const state = ref('selecting');
        const paymentState = ref(null);
        


        // ! data for test 
        // const paymentState = ref({
        //     "sourceId": "citilinebc",
        //     "sourceName": "Citi Line BC",
        //     "sourceLogoUrl": "https://stgstorageewallet.blob.core.windows.net/issuers/citi2.png",
        //     "targetId": "104477",
        //     "targetName": "True Coffee",
        //     "targetLogoUrl": "http://stg-api-buzzebees.cloudapp.net/api/agency/104477/picture?time=20170927011136",
        //     "pointToUse": 10.0,
        //     "rate": "1:0.2",
        //     "amount": 50.0,
        //     "qrID": "BZBS|SmFGob_Nj-ZwLRwhwneb9SDXz1XceAH9km|merchant|||104477|0000001|10|||1700993850"
        // });


        // setup modal
        useModalSetup(ModalStore)

        const landingFlow = LandingFlow({
            mainAppName: "paywithpoint"
        },
            AccountStore,
            LocaleStore
        )

        console.log('LandingFlow',landingFlow)

        function changeState(stateValue) {
            state.value = stateValue

            // Handler state for without amount
            if(state.value == 'qrcodewithouteamount' && paymentState.value == null){
                callGenQRCodeApi()
                state.value = 'selecting'
            }

        }
        function updatePayment(statement){
            paymentState.value = statement
            changeState('qrcodeamount')
        }

        function callGenQRCodeApi() {
            let  redeemParams = new CreateQRModel();
            const profile = landingFlow.states.profile.profile

            const appId = landingFlow.states.query.appId;
            const userId = profile.userId;
            const appMain = landingFlow.states.mainAppName;
            const wtoken = landingFlow.states.query.wallet_token;
            const apiPrefix = landingFlow.states.query.apiPrefix;
            const weblandingBlob = landingFlow.states.blobWebLanding;
            const walletCardId = landingFlow.states.query.walletCardId;
            const isDeductBzbsApp = !walletCardId ? true : landingFlow.states.query.isDeductBzbsApp

            redeemParams.setDataFromObject({
                appId : appId,
                userId : userId,
                cardId : landingFlow.states.query.walletCardId || null,
                isDeductBzbsApp : isDeductBzbsApp
            }); 
            let params = redeemParams.getParams()

            Service.apiGenQrCode(appMain, wtoken, apiPrefix, weblandingBlob, params, null, landingFlow.states, isDeductBzbsApp).subscribe({
                next: (res) => {
                    showSerial(res);
                    console.log(res)
                },
                error: (err) => {
                    console.log(err)
                    errorApi(err)
                }
            })
                
        }

        function showSerial(serialData) {
            var serial = new SerialModel();
                serial.setModelFromDataModel(serialData);
            modalController.serialModal
                    .clearModal()
                    .setSerial(serial)
                    .setStates(landingFlow.states)
                    .show()
            modalController.serialModal.onCloseModal(() => {

            })

            modalController.serialModal.onScanSuccess((res) => {
                    console.log(res)
                modalController.successModal
                        .clearModal()
                        .setTitle(lbl.value.redeem_success.qr_redeem_success)
                        .setMsg(lbl.value.redeem_success.qr_redeem_success_detail)
                        .setBlobConfig(landingFlow.states)
                        .setBtnOk(lbl.value.base_button.close)
                        .show()
            })

            modalController.serialModal.onScanError((res) => {
                    console.log(res)
                    // used same ui as success modal
                modalController.successModal
                        .clearModal()
                        .setTitle(lbl.value.redeem_success.qr_redeem_error)
                        .setMsg(lbl.value.redeem_success.qr_redeem_error_detail)
                        .setBlobConfig(landingFlow.states)
                        .setBtnOk(lbl.value.base_button.close)
                        .show()
            })
        }

        provide("ModalStore", ModalStore)
        provide("LocaleStore", LocaleStore)
        provide("AccountStore", AccountStore)

        onMounted(() => {
            if (route.query?.locale != null) {
                LocaleStore.setters.setLocale(route.query?.locale);
            }
        })

        return {
            modalController: modalController,
            landingFlow,
            lbl:lbl,
            isPageReady: landingFlow.isPageReady,
            route: route,
            state,
            paymentState,
            changeState,
            updatePayment,
            errorApi
        }
    },
    data: function () {
        return {
            isLoaded: false,
            theme: "template_apiservice",
            citiPoint: null,
            dataRate: null,
            
        }
    },
    mounted: function () {
        this.initLanding()
    },
    created: function() { 
    },
    methods: {
        initLanding: async function () {    
            this.init();
        },  
        clickBack: function() { 
            if(this.state != 'selecting'){
                // Clear payment state
                // this.paymentState = null
                this.changeState('selecting')
            }else{
                if (!Util.isEmptyStr(this.landingFlow.states.query.returnUrl)) {
                    window.location.replace(this.landingFlow.states.query.returnUrl);
                }
            }
            }, 
        init: function () {
            // config landing flow
            this.modalController.loadingModal.show()
            this.landingFlow.events.onError = (err) => {
                console.log("init error", err)
            }
            this.landingFlow.events.onReady = async () => {
                // console.log("isPageReady", isPageReady)
                this.getPoints();
            }
            // start initial 
            this.landingFlow.init()
        },
        isCitiLine: function() {
            if (this.landingFlow.states.query.appName == "citilinebc") {
                return true;
            }
            else {
                return false;
            }
        },
        getPoints: async function() {
            await this.getRate();
            if (this.isCitiLine()) {
                await this.getWallet();
                this.modalController.loadingModal.hide()
            } else {
                this.modalController.loadingModal.hide()
            }
            this.welcomePopup();
        },
        getRate: async function() {
            var appMain = this.landingFlow.states.mainAppName;
            var apiPrefix = this.landingFlow.states.query.apiPrefix;
            // var token = this.landingFlow.states.query.token;
            var wtoken = this.landingFlow.states.query.wallet_token;
            var campaignId = this.landingFlow.states.query.campaignId;
            var weblandingBlob = this.landingFlow.states.blobWebLanding;
            var cardId = this.landingFlow.states.query.walletCardId;

            Service.getRate(appMain, wtoken, campaignId, apiPrefix, weblandingBlob, cardId).then((resp) => {
                    this.dataRate = resp.data?.Data;
                    
                    if (!this.isCitiLine()) {
                        this.isLoaded = true;
                    }
                }).catch((err) => {
                    console.log(err)
                    if (!this.isCitiLine()) {
                        this.isLoaded = true;
                    }else{
                        this.errorApi(err)
                    }
                })
        },
        getWallet: async function() {
            var appMain = this.landingFlow.states.mainAppName;
            var token = this.landingFlow.states.query.token;
            var jwt = this.landingFlow.states.query.jwt;
            var cardId = this.landingFlow.states.query.walletCardId;
            var wtoken = this.landingFlow.states.query.wallet_token;
            var apiPrefix = this.landingFlow.states.query.apiPrefix;
            var weblandingBlob = this.landingFlow.states.blobWebLanding;

            Service.getCitiBalancePoint( appMain, cardId, token, wtoken, apiPrefix, weblandingBlob, jwt).then((resp) => {
                    this.landingFlow.states.citiPoint = resp
                    this.isLoaded = true;
                    // console.log(this.landingFlow)
                }).catch((err) => {
                    console.log(err)
                    this.isLoaded = true;
                    this.errorApi(err)
                })
        },
        
        clickPdpa: function() {
            var msg =  Util.newLineToBr(this.landingFlow.states.query.locale == 1033 ? this.landingFlow.states.campaign.conditionEN : this.landingFlow.states.campaign.condition)
            this.modalController.pdpaContentModal
                .clearModal()
                .setTitle(this.lbl.terms_conditions.title)
                .setMsg(msg)
                .setBtnOk(this.lbl.terms_conditions.close)
                .show()
        },
        welcomePopup: function() {
            const KEY_COOKIE_POPUP_WELCOME = 'mePoint'
            let cache = new CacheHelper('session');
            let wlecome = cache.getCache(KEY_COOKIE_POPUP_WELCOME)
            if (wlecome == null) {
                cache.setCache(KEY_COOKIE_POPUP_WELCOME,1)
                this.modalController.alertModal
                    .clearModal()
                    .setTitle(this.lbl.welcome.title)
                    .setMsg(this.lbl.welcome.msg)
                    .setBtnCancel(this.lbl.alert.close_btn)
                    .show()
            }
        },
    }
}
</script>

<style lang="scss">
@import '../style/main.scss';
</style>
<style lang="scss" scoped>
@import '../style/base.scss';
.paywithpoint-page {
    min-height: 100vh;
}
.bg-page {
    background-image: url(../assets/bg/bg-CreateVoucher.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: top center;
    @include tablet {
        margin: 25px 0 0;
        background-image: url(../assets/bg/bg-CreateVoucher-tablet.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top center;
    }
}
</style>
